<template>
  <Flex direction="column">
    <BaseText bold>
      {{ $t('onboarding.new_onboarding.services.title') }}
    </BaseText>
    <div :class="$style.baseContainer">
      <BaseButtonList
        v-model="categoryName"
        :options="categories"
        v-test="'btn-onboarding-category'"
      />
      <img
        v-if="$screen !== 's'"
        :src="`/img/onboarding/${companyImage}.svg`"
        :class="$style.img"
      >
    </div>
  </Flex>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { companyImage } from './onboarding-utils';

const emits = defineEmits(['update:modelValue']);
const props = defineProps<{
  modelValue: string;
  categories: any[];
}>();

const categoryName = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
});
</script>

<style
  lang="scss"
  module
>
.baseContainer {
  display: flex;
  align-items: center;
}

.img {
  height: 175px;
}
</style>
